import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-help-dialog',
  templateUrl: './help-dialog.component.html',
  styleUrl: './help-dialog.component.scss'
})
export class HelpDialogComponent implements OnInit{

  description: any;
  gif: any;
  //@ts-ignore
  title: string;
  //@ts-ignore
  step: number;
  //@ts-ignore
  activeItem: number;
  disableNext: boolean = false;
  disableBack: boolean = true;

  constructor(
    private sanitizer: DomSanitizer, 
    private dialogRef: MatDialogRef<HelpDialogComponent>,
    ) { }

  ngOnInit(): void {
    this.step = 1;
    this.nextStep();
  }

  selectSubItem(subItem: Menu) {
    this.gif = '';
    this.title = subItem.name;
    this.description = subItem.description;
    this.gif = subItem.gif;
    this.activeItem = subItem.value;
    this.step = subItem.value;
    this.buttonLogic();
  }

  setStep(item: Menu) {
    this.step = item.value + 1;
    if (item.subItems) this.selectSubItem(item.subItems[0]);
    this.buttonLogic();
  }

  buttonLogic() {
    if (this.step >= 3) {
      this.disableBack = false;
    }
    if (this.step <= 2) {
      this.disableBack = true;
    }
    if (this.step === 12) {
      this.disableNext = true;
    }
    if (this.step <= 11) {
      this.disableNext = false;
    }
  }

  nextStep() {
    this.step++;
    if (
      this.step === 1  || // homepage
      this.step === 5     // create a new account 
    ) {
      this.menu.forEach((m) => {
        if (m.value === this.step) {
          m.expanded = true;
        } else m.expanded = false;
      });
      this.step++;
    }
    this.buttonLogic();
    this.activeItem = this.step;
    this.menu.forEach((m) => {

      m.subItems?.forEach((e) => {
        if (e.value === this.activeItem) {
          this.title = e.name;
          this.description = e.description;
          this.gif = e.gif;
        }
      });

    });
  }

  prevStep() {
    this.step--;
    if (
      this.step === 1  || // homepage
      this.step === 5    // create a new account
    ) {
      this.menu.forEach((m) => {
        m.expanded = false;
        if (this.step === m.value) {
          this.step--;
          m.expanded = false;
        }
      });
    }
    this.buttonLogic();
    this.activeItem = this.step;

    this.menu.forEach((p) => {
      p.subItems?.forEach((r) => {
        if (r.value === this.activeItem) {

          p.expanded = true;
          this.title = r.name;
          this.description = this.sanitizer.bypassSecurityTrustHtml(r.description);
          this.gif = r.gif;
        }
      });
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  menu: Menu[] = [
    {
      value: 1, 
      name: 'Homepage',
      description: '',
      expanded: true, 
      gif: '', 
      subItems: [
        {
          value: 2, 
          name: 'Getting Started', 
          description: 'Welcome to CloudServe. Create a cloud account in AWS and view existing account statuses all in one place. To begin, create a new account using the green button.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/Homepage-Getting-Started.png'
        }, 
        {
          value: 3, 
          name: 'Existing Accounts', 
          description: 'View your existing AWS accounts and <b>basic</b> account information. Information such as account name, status, environment and ASMS are available on the tiles. Hover over an icon to.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/Homepage-Existing-Accounts.png'
        }, 
        {
          value: 4, 
          name: 'Account Statuses', 
          description: 'The Three statuses for accounts are In Progress, Error, and Completed. Accounts with an Error status are inactive and need to be addressed by the CloudServe team.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/Homepage-Account-Statuses.png'
        }
      ]
    }, 

    {
      value: 5, 
      name: 'Create a New Account', 
      description: '', 
      expanded: false, 
      gif: '', 
      subItems: [
        {
          value: 6, 
          name: 'Account Details', 
          description: 'Enter the ASMS ID and owner email address. The account must be associated with an app ASMS.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/Account-Details.png'
        }, 
        {
          value: 7, 
          name: 'Environment', 
          description: 'Choose the development environment for the account. Currently only the Dev environment is being supported. Please note – You can only create one account per environment for an ASMS.', 
          subItems: [],
          gif: '../../../assets/walkthrough-images/Environment.png'
        }, 
        {
          value: 8, 
          name: 'Region', 
          description: 'Choose the region where your account will be created in. Currently, the only region supported is North America.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/region.png'
        }, 
        {
          value: 9, 
          name: 'Managed Organization Unit', 
          description: 'Select the available subscription network model for your account. Currently, the only option is DevZone.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/Managed-Organization-Unit.png'
        }, 
        {
          value: 10, 
          name: 'Size and Pricing', 
          description: 'From the dropdown, select between Small, Medium, or Large for the storage compute size.',
          subItems: [], 
          gif: '../../../assets/walkthrough-images/Size-and-Pricing.png'
        }, 
        {
          value: 11, 
          name: 'Confirmation', 
          description: 'Review all your information before submitting. Once you are satisfied with your inputs, press the ‘Submit’ button at the bottom of the form to kick off account creation.', 
          subItems: [], 
          gif: '../../../assets/walkthrough-images/confirmation-page.png'
        }, 
        {
          value: 12, 
          name: 'Resources', 
          description: 'Resources are available at the bottom of the site. Select the icon or title of the resource to be redirected.', 
          subItems:[], 
          gif: '../../../assets/walkthrough-images/resources.png'
        }
      ]
    }
  ];



}

interface Menu {
  value: number;
  name: string;
  subItems?: Menu[];
  description: any;
  expanded?: boolean;
  gif?: string
}

